import { activityTimelineModel } from '@/features/chat/phase1/activityTimelineModel'
import { isActivityTimelineDrafting } from '@/features/chat/phase1/timelineHeaderLabel'
import ActivityTimelineBody from './timeline/ActivityTimelineBody'
import { useActivityTimelineNow } from './useActivityTimelineNow'
import { useActivityTimelineOpen } from './useActivityTimelineOpen'
import { useActivityTimelineRunClock } from './useActivityTimelineRunClock'

const EMPTY_PUBLIC_ACTIVITY = { phases: [], steps: [] }

export default function ActivityTimeline({
  activity = [],
  workStatus = null,
  streaming = false,
  hasArtifacts = false,
  runId = null,
  publicActivity = EMPTY_PUBLIC_ACTIVITY,
  citations = [],
  thoughtSummary = null,
  thoughtDetails = [],
  hasResponseText = false,
}) {
  const isDrafting = isActivityTimelineDrafting({ hasResponseText, thoughtSummary })
  const now = useActivityTimelineNow(streaming)
  const { startedAt: clientRunStartedAt, completedAt: clientRunCompletedAt } =
    useActivityTimelineRunClock(streaming, runId)
  const { expanded, onToggle } = useActivityTimelineOpen(streaming, isDrafting)
  const model = activityTimelineModel({
    activity,
    workStatus,
    hasArtifacts,
    runId,
    publicActivity,
    thoughtSummary,
    thoughtDetails,
    streaming,
    now,
    hasResponseText,
    clientRunStartedAt,
    clientRunCompletedAt,
  })
  if (!model.visible) return null
  return (
    <ActivityTimelineBody
      model={model}
      streaming={streaming}
      open={expanded}
      onToggle={onToggle}
      publicActivity={publicActivity}
      citations={citations}
    />
  )
}
